import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
//   mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/početna'
    },
    {
      path: '/početna',
      name: 'Home',
      component: () => import('@/views/HomePage')
    },
    {
      path: '/kontakt',
      name: 'Contact',
      component: () => import('@/views/ContactPage')
    },
    {
      path: '/usluge',
      name: 'Services',
	  component: () => import('@/views/ServicesPage'),
	  props: true
    },
    {
      path: '/galerija',
      name: 'Gallery',
      component: () => import('@/views/GalleryPage')
    },
    {
      path: '/reference',
      name: 'References',
      component: () => import('@/views/ReferencesPage')
    },
    // {
    //   path: '/about',
    //   name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
